import { instance } from "libs/api";

import { ApiRoutesRecommendation } from "../../constants";
import { CategoryEnrichmentProfile } from "../../recommendation.types";

export const requestGetEnrichmentProfiles = async (): Promise<
  CategoryEnrichmentProfile[]
> => {
  return await instance.get(ApiRoutesRecommendation.EnrichmentProfiles);
};
